import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    color: 'rgba(34, 34, 34, 0.1)',
    fontSize: '0.625rem',
    lineHeight: 1.1,
  },
  right: {
    padding: '0 0.25rem 0.25rem 0',
    textAlign: 'right',
  },
  left: {
    padding: '0 0 0.25rem 0.25rem',
  },
}));
